import request from '@/utils/request'

export default {
  // 获取所有的菜单权限
  getAllPermissionsMenu(data) {
    return request({
      // url: `/admin/commonPermission/get/allPermissions/emi`,
      url: '/emi/account/getAllPermission',
      method: 'post',
      params: data
    })
  },
  getWatermarkParamStr() {
    return request({
      url: `/doctor/hospitalDoctor/getWatermarkParamStr`,
      method: 'post'
    })
  },
  // 登录
  login(data) {
    return request({ url: '/emi/account/login', method: 'post', data })
  },
  // 登出
  loginOut(data) {
    return request({ url: '/emi/account/logOut', method: 'post', data })
  },
  // 账户列表
  postAccountList(data = {}) {
    return request({
      url: `/emi/account/list`,
      method: 'post',
      data
    })
  },
  // 账户详情
  postAccountDetail(data = {}) {
    return request({
      url: `/emi/account/info`,
      method: 'post',
      data
    })
  },
  // 添加账户
  postAccountAdd(data = {}) {
    return request({
      url: `/emi/account/add`,
      method: 'post',
      data
    })
  },
  // 编辑账户
  postAccountUpdate(data = {}) {
    return request({
      url: `/emi/account/update`,
      method: 'post',
      data
    })
  },
  // 账户启用停用
  postAccountState(data = {}) {
    return request({
      url: `/emi/account/updateSate`,
      method: 'post',
      data
    })
  },
  // 账户权限
  postAccountPermission(data = {}) {
    return request({
      url: `/emi/account/permission`,
      method: 'post',
      data
    })
  },
  // 修改密码
  postAccountUpdatePwd(data = {}) {
    return request({
      url: `/emi/account/updatePwd`,
      method: 'post',
      data
    })
  },
  // 说明书列表
  postDrugBookList(data = {}) {
    return request({
      url: `/emi/drugBook/list`,
      method: 'post',
      data
    })
  },

  // 发送登陆验证码
  postAccountSendLoginSms(data = {}) {
    return request({
      url: `/emi/account/sendLoginSms`,
      method: 'post',
      data
    })
  },
  // 发送忘记密码验证码
  postAccountSendRenewPwdSms(data = {}) {
    return request({
      url: `/emi/account/sendRenewPwdSms`,
      method: 'post',
      data
    })
  },
  // 忘记密码
  postAccountRenewPwd(data = {}) {
    return request({
      url: `/emi/account/renewPwd`,
      method: 'post',
      data
    })
  },
  // 获取三级等保
  securityConf(data = {}) {
    return request({
      method: 'GET',
      url: '/admin/commonConfig/get/securityConf',
      data
    })
  }
}
